module.exports = __webpack_public_path__ + "img/trade-img.40fc163a.png";